import {
  type BackyardLocationId,
  isBackyardLocationId,
} from '@/world-prototype/camera/sceneWorld';

const LOCATION_BADGE_SRC: Readonly<Record<BackyardLocationId, string>> = {
  hubert: `${import.meta.env.BASE_URL}art/ui/hubert-location.png`,
  raleigh: `${import.meta.env.BASE_URL}art/ui/holly-springs-location.png`,
  'spanish-fork': `${import.meta.env.BASE_URL}art/ui/spanish-fork-location.png`,
};

/** Illustrated storybook location badge for backyard HUD. */
export function locationBadgeSrc(
  locationId: string | null | undefined,
): string | null {
  if (!isBackyardLocationId(locationId)) return null;
  return LOCATION_BADGE_SRC[locationId];
}
